const dynamicPhoto = {
  UltTitle: 'HitPaw Online Animar Fotos Antigas',
  priceWeek: 'R$19,99',
  priceMonth: 'R$9,99',
  priceYear: 'R$5,99',
  week: 'Semana',
  Monthly: 'Mensualmente',
  Weekly: 'Semanalmente',
  Yearly: 'Anualmente',
  monthTotalPrice: 'R$39,99 Pagado Mensualmente',
  yearTotalPrice: 'R$249,99 Pagado Anualmente',
  NoImageSizeLimits: 'Sem Limites de Tamanho de Imagem',
  UnlimitedImageUploads: 'Uploads de Imagem Ilimitados',
  DownloadWithoutWatermark: "Baixe a Imagem HD sem Marca d'água",
  DownloadGif: 'Baixe o Vídeo como GIF',
};

export default dynamicPhoto;
